<template>
  <div class="on-pending-state" @click="clickHandler">
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9995 8.00018V12.0002M10.9995 15.0002H11.0095M9.3625 2.59119L1.2565 16.1252C1.08939 16.4146 1.00096 16.7427 1.00001 17.0768C0.999051 17.411 1.0856 17.7396 1.25104 18.0299C1.41649 18.3203 1.65506 18.5622 1.94304 18.7317C2.23101 18.9013 2.55835 18.9924 2.8925 18.9962H19.1065C19.4405 18.9923 19.7677 18.9011 20.0555 18.7317C20.3433 18.5622 20.5818 18.3204 20.7472 18.0302C20.9126 17.74 20.9992 17.4116 20.9984 17.0776C20.9976 16.7435 20.9094 16.4155 20.7425 16.1262L12.6365 2.59019C12.466 2.30869 12.2257 2.07593 11.9389 1.91439C11.6522 1.75284 11.3286 1.66797 10.9995 1.66797C10.6704 1.66797 10.3468 1.75284 10.06 1.91439C9.77329 2.07593 9.53304 2.30869 9.3625 2.59019V2.59119Z"
        stroke="#D92D20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    clickHandler() {
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss">
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }
  .no-padding {
    padding-left: 0 !important;
  }
}

.dx-tagbox-popup-wrapper {
  .dx-list-item-before-bag.dx-list-select-checkbox-container {
    width: 28px !important;
  }
}

.gc-field-tag-dropDown {
  .dx-item.dx-list-item {
    display: inline-flex;
    .dx-list-select-checkbox-container {
      padding-top: 12px;
    }
  }

  .auto-complete-secondary {
    padding-left: unset !important;
  }
}
</style>
